import styled from 'styled-components'
import { rem } from 'polished'
import variables from 'styles/vendor/bootstrap/variables'
import { clearfix } from 'styles/vendor/bootstrap/helpers'

const Row = styled.div`
  ${clearfix}
  margin-right: ${rem(variables.gutterWidth / -2)};
  margin-left: ${rem(variables.gutterWidth / -2)};
`

export default Row
